export { RoomsVersion as Rooms } from './RoomsVersion';
